/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Exportascsv2Inputs */

const en_btn_exportascsv2 = /** @type {(inputs: Btn_Exportascsv2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export as CSV`)
};

/**
* | output |
* | --- |
* | "Export as CSV" |
*
* @param {Btn_Exportascsv2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_exportascsv2 = /** @type {((inputs?: Btn_Exportascsv2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Exportascsv2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_exportascsv2(inputs)
});
export { btn_exportascsv2 as "btn_exportAsCsv" }